import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { Field } from '../../models/home';
import { FIELD_NAMES, REGEX } from '../../constants/common';
import { UpdateEmailPayload } from '../../models/common';
import { useTranslation } from 'react-i18next';

interface Props {
    updateEmailPayload: UpdateEmailPayload;
    setUpdateEmailPayload: Dispatch<SetStateAction<UpdateEmailPayload>>;
    updateEmail: () => void;
};

export const useUpdateEmailPopUp = ({updateEmailPayload, setUpdateEmailPayload, updateEmail}: Props) => {
    const { t } = useTranslation();
    const [emailField, setEmailField] = useState<Field>({
        name: FIELD_NAMES.email,
        value: updateEmailPayload.passengerEmailAddress,
        error: '',
        requiredError: ''
    }); 

    useEffect(() => {
        if (emailField.value) {
            setUpdateEmailPayload({
                ...updateEmailPayload,
                passengerEmailAddress: emailField.value
            });
        }

    }, [emailField, updateEmailPayload, setUpdateEmailPayload]);

    const handleOnBlur = () => {
        if (emailField.value && !REGEX.email.test(emailField.value)) {
            setEmailField({...emailField, error: t('validations.email')});
        } else {
            setEmailField({...emailField, error: ''});
        }
    };

    const handleOnChange = (event) => {
        const value = event.target.value;
        setEmailField({...emailField, value: value});
    };

    const handleOnSave = () => {
        if (!emailField.value) {
            setEmailField({...emailField, requiredError: t('validations.email')});
            return;
        }
        if (emailField.error) return; 
        updateEmail();
    };

    return {
        emailField,
        handleOnBlur,
        handleOnChange,
        handleOnSave,
        t
    };
};

